/*
* @About gongw created by 2021/2/23
* ⚠️ 生产环境必须走 nginx /api 反代，禁止直连 IP（避免跨域 + 混合内容）
*/
let baseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // 部署到 https://www.ygctszfw.com 后，/api 由 nginx 反代到 124.222.29.81:8998
  baseUrl = '/api'
} else {
  // 本地开发：直连后端 IP，方便调试；如需与生产一致也可改为 '/api'
  baseUrl = 'http://124.222.29.81:8998'
}
export default baseUrl

